/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AcademyStudioAnnouncementChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_academy_studio_rpc_services_AcademyStudioAnnouncementChirpService_getById';
export const GET_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService#getPaginatedResponse
 */
export const GET_PAGINATED_RESPONSE_QUERY_FIELD_NAME = 'com_hubspot_academy_studio_rpc_services_AcademyStudioAnnouncementChirpService_getPaginatedResponse';
export const GET_PAGINATED_RESPONSE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAGINATED_RESPONSE_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPaginatedResponseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService#getActiveByLanguage
 */
export const GET_ACTIVE_BY_LANGUAGE_QUERY_FIELD_NAME = 'com_hubspot_academy_studio_rpc_services_AcademyStudioAnnouncementChirpService_getActiveByLanguage';
export const GET_ACTIVE_BY_LANGUAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_BY_LANGUAGE_QUERY_FIELD_NAME,
  args: ['language'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getActiveByLanguageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService#createAnnouncement
 */
export const CREATE_ANNOUNCEMENT_QUERY_FIELD_NAME = 'com_hubspot_academy_studio_rpc_services_AcademyStudioAnnouncementChirpService_createAnnouncement';
export const CREATE_ANNOUNCEMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CREATE_ANNOUNCEMENT_QUERY_FIELD_NAME,
  args: ['title', 'body', 'ctaText', 'ctaUrl', 'banner', 'language', 'embeddedContentType', 'embeddedId', 'publishedAt', 'unpublishedAt', 'announcementState', 'embeddedContents'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.createAnnouncementRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService#updateAnnouncement
 */
export const UPDATE_ANNOUNCEMENT_QUERY_FIELD_NAME = 'com_hubspot_academy_studio_rpc_services_AcademyStudioAnnouncementChirpService_updateAnnouncement';
export const UPDATE_ANNOUNCEMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: UPDATE_ANNOUNCEMENT_QUERY_FIELD_NAME,
  args: ['id', 'title', 'body', 'ctaText', 'ctaUrl', 'banner', 'language', 'embeddedContentType', 'embeddedId', 'publishedAt', 'unpublishedAt', 'announcementState', 'embeddedContents'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateAnnouncementRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService#deleteAnnouncement
 */
export const DELETE_ANNOUNCEMENT_QUERY_FIELD_NAME = 'com_hubspot_academy_studio_rpc_services_AcademyStudioAnnouncementChirpService_deleteAnnouncement';
export const DELETE_ANNOUNCEMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DELETE_ANNOUNCEMENT_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.deleteAnnouncementRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});